const errorsDictionary = {
  name: {
    required: 'Campo nome é obrigatório.'
  },
  email: {
    required: 'Campo e-mail é obrigatório.',
    pattern: 'Digite um e-mail válido'
  },
  cep: {
    required: 'Campo cep é obrigatório.',
    pattern: 'Digite um cep válido',
    maxLength: 'Você só pode digitar 8 caracteres'
  },
  state: {
    required: 'Campo estado é obrigatório.'
  },
  city: {
    required: 'Campo cidade é obrigatório.'
  },
  street: {
    required: 'Campo logadrouro é obrigatório.'
  },
  district: {
    required: 'Campo bairro é obrigatório.'
  },
  number: {
    required: 'Campo número é obrigatório.'
  },
  birthDate: {
    required: 'Campo data de nascimento é obrigatório.',
    pattern: 'Digite uma data válida.',
    validate: 'Você precisa ter entre 18 e 100 anos para participar'
  },
  region: {
    required: 'Campo região é obrigatório.'
  },
  favoriteStore: {
    required: 'Campo loja favorita é obrigatório.'
  },
  occupation: {
    required: 'Campo profissão é obrigatório.'
  }
}

export default (key, errors, defaultMessage = '') => {
  if (!errors) {
    throw new Error('Errors object is required')
  }

  if (!errors[key]) {
    return defaultMessage
  }

  switch (errors[key].type) {
    case 'pattern':
      return errorsDictionary[key].pattern

    case 'validate':
      return errorsDictionary[key].validate

    case 'required':
      return errorsDictionary[key].required

    case 'maxLength':
      return errorsDictionary[key].maxLength

    default:
      return errorsDictionary[key].message
  }
}
